import EmployeeProfessionalForm from '@/components/Employee/EmployeeProfessionalForm';
import DefaultRouteTabs from '@/components/_common/DefaultRouteTabs';
import { Form, Skeleton } from 'antd';
import { SaveButton } from '@/components/_common';
import { PageProps } from '@/types/PageProps';
import { useEmployeeProfessional } from '@/core/domain/enterprise/Employees/Employees.hooks';
import { useEffect } from 'react';
import { EmployeeProfessionalFormValues } from '@/core/domain/enterprise/Employees/Employees.types';
import moment from 'moment';
import { useEmployeeFormContext } from '@/components/Employee/EmployeeFormProvider';
import EmployeeFooter from '@/components/Employee/EmployeeFooter';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';

const EmployeeProfessionalPage = ({ route }: PageProps) => {
  const { isLoading, forms, instanceForms, employeeId, disabled } =
    useEmployeeFormContext();

  const [form] = Form.useForm<EmployeeProfessionalFormValues>(
    instanceForms.employeeProfessional,
  );

  const { data: employeeProfessional, isLoading: employeeIsLoading } =
    useEmployeeProfessional(employeeId);

  useEffect(() => {
    if (employeeProfessional && !forms.employeeProfessional) {
      form.setFieldsValue({
        ...employeeProfessional,
        admissionDate: employeeProfessional.admissionDate
          ? moment(employeeProfessional.admissionDate)
          : undefined,
        salary: employeeProfessional?.salary,
        partCommission: employeeProfessional?.partCommission || 0,
        serviceCommission: employeeProfessional?.serviceCommission || 0,
        functionId: employeeProfessional?.function?.id,
        ticketPrice: employeeProfessional?.ticketPrice || undefined,
      });
    }
  }, [employeeProfessional, forms.employeeProfessional]);

  async function handleSubmit() {
    try {
      await form.validateFields();
      form.submit();
    } catch {}
  }

  return (
    <DefaultRouteTabs
      route={route.parent}
      permissions={route.permissions}
      baseKey={String(employeeId)}
      basePath={`/app/registry/employees/${employeeId}`}
      extra={
        <SaveButton
          block
          loading={isLoading}
          onClick={handleSubmit}
          disabled={
            disabled || !hasPermissions([Authorities.REGISTER_EMPLOYEE_EDIT])
          }
        >
          Salvar
        </SaveButton>
      }
    >
      <Skeleton loading={employeeIsLoading}>
        <EmployeeProfessionalForm form={form} />

        <EmployeeFooter disabled={disabled} form={form} />
      </Skeleton>
    </DefaultRouteTabs>
  );
};

export default EmployeeProfessionalPage;
